const wrapper = "dibw1mfacu";
const toast = "dibt10juu6y";
const messageIcon = "dibm12eidp9";
const closeButton = "dibc1aews78";
const success = "dibsybexj6";
const error = "dibe1mgwbcv";

export { closeButton, error, messageIcon, success, toast, wrapper };
import "./toast.style.linaria.module.css";
//# sourceMappingURL=toast.style.js.map
